import $ from 'jquery';
import SidebarParamClinique from './sidebar-param-clinique'
import SidebarClinique from './sidebar-clinique'
import SidebarMDT from './sidebar-mdt'

export default {
    name: 'sidebar',
    components: {
        SidebarParamClinique, SidebarClinique,
        SidebarMDT
    },
    props: [],
    data() {
        return {
            user_role: '',           //  Role d'un utilisateur
            is_param: false
        }
    },
    computed: {
        /**
         * Get User info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },
    mounted() {
        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;
        }

        this.getCurrentPath()
    },

    methods: {
        onSidebarItemClick(e) {
            // Close sidebar when any menu <li> is clicked (mobile behavior),
            // but don't close when the click is only meant to expand/collapse a submenu.
            const $target = $(e.target);
            if ($target.closest('a[data-toggle="collapse"]').length) return;

            // Only react to clicks within an <li> inside the menu
            if (!$target.closest('li').length) return;

            this.getCurrentPath();
            this.closeSidebar();
        },
        
        toggleClassChevron: function (htmlclass) {
            let className = $('.' + htmlclass + " .chevron i").attr('class')

            if (className === "fa fa-chevron-down ico-small") {
                $('.' + htmlclass + " .chevron i").removeClass('fa-chevron-down ico-small')
                $('.' + htmlclass + " .chevron i").addClass("fa-chevron-up ico-small")
            } else {
                $('.' + htmlclass + " .chevron i").removeClass('fa-chevron-up ico-small')
                $('.' + htmlclass + " .chevron i").addClass("fa-chevron-down ico-small")
            }
        },

        getCurrentPath() {
            let path = this.$route.path
            
            this.is_param = path.includes("parametres")
        },

        closeSidebar() {
            const sidebar = $('#sdbr');
            if (sidebar.hasClass('shw-sdbar')) {
                sidebar.removeClass('shw-sdbar');
                // Trigger toggleSidebar in navbar to update the icon state
                this.$root.$emit('closeSidebar');
            }
        }
    }
}


